//local api URL `http://127.0.0.1:8000/api`;
//host api URL `https://belmenyonline.com/api/public/api`;



//export const baseURL = `http://127.0.0.1:8000/api`;
export const baseURL = `https://belmenyonline.com/api/public/api`;
